import React from 'react';
import {Logo_transparent } from "utils/assets/images"




const Logo = ({ height = 32, toggleWhite }) => (
    <img alt='logo' style={{height: '160px'}} src={Logo_transparent}></img>
);

export default Logo;